import cookieService from '../services/cookieService';
import { ACCESS_TOKEN_COOKIE } from '../config';
import getProviderRegion from './getProviderRegion';
import { getApiTargetHeader } from './apiTarget';

const getHeaders = (customHeaders) => {
  const accessToken = cookieService.getCookie(ACCESS_TOKEN_COOKIE);
  const providerRegion = getProviderRegion();

  return {
    headers: {
      'x-auth-token': accessToken,
      ...(providerRegion && { 'x-provider-region': providerRegion }),
      ...getApiTargetHeader(),
      ...(customHeaders || {}),
    },
  };
};

export default getHeaders;
